import type { Component } from 'solid-js'
import { For, Show } from 'solid-js'
import Button from '~/components/Button'
import Card from '~/components/Card'
import Icon from '~/components/Icon'
import { P } from '~/utils/permissions'
import type { TabActividadesProps } from './types'
import { activityColor, activityIcon } from './utils'

const TabActividades: Component<TabActividadesProps> = props => {
  return (
    <>
      <div class="flex justify-end mb-4">
        <Show when={props.can(P.customers.update)}>
          <Button size="sm" variant="soft" color="primary" onClick={() => props.setActivityModal(true)} prependIcon="material-symbols-light:add">
            Registrar actividad
          </Button>
        </Show>
      </div>
      <Card>
        <Card.Body>
          <div class="relative border-l-2 border-border pl-6 ml-3 space-y-6">
            <For each={props.data.activities ?? []} fallback={<p class="text-foreground-subtle">Sin actividad registrada.</p>}>
              {activity => (
                <div class="relative">
                  <span class={`absolute -left-[35px] top-0 size-6 rounded-full flex items-center justify-center ${activityColor[activity.type] ?? activityColor.custom}`}>
                    <Icon icon={activityIcon[activity.type] ?? activityIcon.custom} size={14} />
                  </span>
                  <div class="flex items-center justify-between gap-2">
                    <p class="font-medium text-foreground">{activity.title}</p>
                    <span class="text-xs text-foreground-subtle shrink-0">{new Date(activity.occurredAt).toLocaleString('es-CO')}</span>
                  </div>
                  <Show when={activity.description}>
                    <p class="text-sm text-foreground-subtle mt-1">{activity.description}</p>
                  </Show>
                </div>
              )}
            </For>
          </div>
        </Card.Body>
      </Card>
    </>
  )
}

export default TabActividades
